import * as React from "react"

const Header = ({ title, children }) => (
  <div className="flex justify-between mb-3 items-center">
    <h2 className="text-2xl sm:text-3xl text-gray-900 font-bold">{title}</h2>
    <div className="flex gap-2">{children}</div>
  </div>
)
export default Header
